import i18n from "../i18n";

const ROLES = ["OWNER", "ADMIN", "COACH", "STUDENT", "ASSOCIATE"] as const;

/** A club role in the current UI language; unknown values come back as they are. */
export const roleLabel = (role: string): string =>
  (ROLES as readonly string[]).includes(role) ? i18n.t(`common:roles.${role as (typeof ROLES)[number]}`) : role;
